import { conf } from '../config/config';

const apiEndpoint = (path) => `${conf.endpoint.replace(/\/$/, '')}${path}`;

async function parseResponse(response, fallbackMessage) {
    const result = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(result.error?.message || fallbackMessage);
    }
    return result.data;
}

export async function uploadCastingPhoto(file) {
    if (!file || !file.name || !file.type || !Number.isFinite(file.size)) {
        throw new Error('We could not prepare the photo upload. Please choose a valid image.');
    }

    const upload = await parseResponse(await fetch(apiEndpoint('/api/casting/photos/upload-url'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            filename: file.name,
            contentType: file.type,
            size: file.size
        })
    }), 'We could not prepare the photo upload. Please try again.');

    if (!upload || !upload.uploadUrl || !upload.photoUrl) {
        throw new Error('We could not prepare the photo upload. Please try again.');
    }

    const uploadHeaders = {
        'Content-Type': file.type,
        'Cache-Control': 'public, max-age=31536000, immutable',
        ...(upload.headers || upload.uploadHeaders || {})
    };
    const uploadResponse = await fetch(upload.uploadUrl, {
        method: 'PUT',
        headers: uploadHeaders,
        body: file
    });

    if (!uploadResponse.ok) throw new Error('We could not upload one of your photos. Please try again.');
    return upload.photoUrl;
}

export async function submitCasting(payload) {
    const response = await fetch(apiEndpoint('/api/casting'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload)
    });
    return parseResponse(response, 'We could not submit your casting application. Please try again.');
}
